import React from 'react';

function PrivacyPage() {
  const styles = {
    container: {
      maxWidth: '640px',
    },
    card: {
      backgroundColor: '#FFFFFF',
      borderRadius: '14px',
      border: '1px solid #E8E8E8',
      overflow: 'hidden',
    },
    item: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '20px 24px',
      cursor: 'pointer',
      transition: 'background-color 0.15s ease',
      borderBottom: '1px solid #E8E8E8',
    },
    itemLast: {
      borderBottom: 'none',
    },
    itemLeft: {
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
    },
    icon: {
      fontSize: '24px',
      width: '40px',
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#F5F5F5',
      borderRadius: '10px',
      flexShrink: 0,
    },
    textGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: '2px',
    },
    title: {
      fontSize: '15px',
      fontWeight: '600',
      color: '#111827',
      margin: 0,
      letterSpacing: '-0.025em',
    },
    description: {
      fontSize: '13px',
      color: '#71717A',
      margin: 0,
    },
    arrow: {
      fontSize: '18px',
      color: '#A1A1AA',
      flexShrink: 0,
    },
  };

  const items = [
    {
      path: 'https://www.zenithexpense.xyz/privacy-policy',
      icon: '📋',
      title: 'Privacy Policy',
      description: 'How we collect, use, and protect your data',
    },
    {
      path: 'https://www.zenithexpense.xyz/terms-of-service',
      icon: '📜',
      title: 'Terms of Service',
      description: 'Rules and conditions for using Zenith Expense',
    },
  ];

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        {items.map((item, index) => (
          <a
            key={item.path}
            href={item.path}
            style={{
              ...styles.item,
              ...(index === items.length - 1 ? styles.itemLast : {}),
              textDecoration: 'none',
              color: 'inherit',
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#FAFAFA'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
          >
            <div style={styles.itemLeft}>
              <div style={styles.icon}>{item.icon}</div>
              <div style={styles.textGroup}>
                <p style={styles.title}>{item.title}</p>
                <p style={styles.description}>{item.description}</p>
              </div>
            </div>
            <span style={styles.arrow}>&rsaquo;</span>
          </a>
        ))}
      </div>
    </div>
  );
}

export default PrivacyPage;
